import { Routes, Route, Navigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useAuth } from './hooks/useAuth'
import { ProtectedRoute } from './components/ProtectedRoute'
import { DashboardLayout } from './components/layout/DashboardLayout'
import { LoginPage } from './pages/LoginPage'
import { VerifyCodePage } from './pages/VerifyCodePage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { ClientsPage } from './pages/ClientsPage'
import { DashboardPage } from './pages/DashboardPage'
import { UsersPage } from './pages/UsersPage'
import { ResellersPage } from './pages/ResellersPage'
import { WholesalersPage } from './pages/WholesalersPage'
import { AttachedResellersPage } from './pages/AttachedResellersPage'
import { AttachedClientsPage } from './pages/AttachedClientsPage'
import { ActivityLogsPage } from './pages/ActivityLogsPage'
import { SettingsPage } from './pages/SettingsPage'
import { ProfilePage } from './pages/ProfilePage'
import { FacturationPage } from './pages/FacturationPage'
import { UserRole } from './types'

function App() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Chargement...</div>
      </div>
    )
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        limit={3}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        closeButton={false}
        theme="light"
        style={{
          fontFamily: 'var(--font-family)',
          fontSize: 'var(--font-size-sm)',
        }}
      />
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
        />
        <Route
          path="/login/verify"
          element={isAuthenticated ? <Navigate to="/" replace /> : <VerifyCodePage />}
        />
        <Route
          path="/login/forgot-password"
          element={isAuthenticated ? <Navigate to="/" replace /> : <ForgotPasswordPage />}
        />
        <Route
          path="/reset-password/:token"
          element={isAuthenticated ? <Navigate to="/" replace /> : <ResetPasswordPage />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute
              requiredRoles={[
                UserRole.ADMIN,
                UserRole.VIEWER,
                UserRole.RESELLER,
                UserRole.WHOLESALER,
              ]}
            >
              <DashboardLayout>
                <DashboardPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute requiredRoles={[UserRole.ADMIN]}>
              <DashboardLayout>
                <UsersPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resellers"
          element={
            <ProtectedRoute requiredRoles={[UserRole.ADMIN]}>
              <DashboardLayout>
                <ResellersPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/wholesalers"
          element={
            <ProtectedRoute requiredRoles={[UserRole.ADMIN]}>
              <DashboardLayout>
                <WholesalersPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/attached-resellers"
          element={
            <ProtectedRoute requiredRoles={[UserRole.ADMIN, UserRole.WHOLESALER]}>
              <DashboardLayout>
                <AttachedResellersPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/attached-clients"
          element={
            <ProtectedRoute requiredRoles={[UserRole.ADMIN]}>
              <DashboardLayout>
                <AttachedClientsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute
              requiredRoles={[UserRole.ADMIN, UserRole.VIEWER, UserRole.RESELLER]}
            >
              <DashboardLayout>
                <ClientsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/facturation"
          element={
            <ProtectedRoute
              requiredRoles={[
                UserRole.ADMIN,
                UserRole.VIEWER,
                UserRole.RESELLER,
                UserRole.WHOLESALER,
              ]}
            >
              <DashboardLayout>
                <FacturationPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/logs"
          element={
            <ProtectedRoute requiredRoles={[UserRole.ADMIN, UserRole.VIEWER]}>
              <DashboardLayout>
                <ActivityLogsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRoles={[UserRole.ADMIN, UserRole.VIEWER]}>
              <DashboardLayout>
                <SettingsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <ProfilePage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </>
  )
}

export default App
